import {
  Cancel as CancelIcon,
  Edit as EditIcon,
  Save as SaveIcon,
} from '@mui/icons-material';
import { Box, IconButton, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useDemoAppContext } from '../../pages/demo/DemoAppContext';

export const BackendSelector: React.FC = () => {
  const { backendUrl, setBackendUrl } = useDemoAppContext();
  const [isEditing, setIsEditing] = useState(false);
  const [editValue, setEditValue] = useState(backendUrl);

  const handleEdit = () => {
    setEditValue(backendUrl);
    setIsEditing(true);
  };

  const handleSave = () => {
    setBackendUrl(editValue);
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditValue(backendUrl);
    setIsEditing(false);
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      handleSave();
    } else if (event.key === 'Escape') {
      handleCancel();
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
      <Typography variant="body2" color="text.secondary">
        Backend:
      </Typography>

      {isEditing ? (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
          <TextField
            size="small"
            value={editValue}
            onChange={(e) => setEditValue(e.target.value)}
            onKeyDown={handleKeyPress}
            autoFocus
            sx={{ flex: 1 }}
            placeholder="Enter backend URL"
          />
          <IconButton size="small" onClick={handleSave} color="primary">
            <SaveIcon />
          </IconButton>
          <IconButton size="small" onClick={handleCancel} color="error">
            <CancelIcon />
          </IconButton>
        </Box>
      ) : (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flex: 1 }}>
          <Typography
            variant="body2"
            sx={{
              fontFamily: 'monospace',
              color: 'text.secondary',
              cursor: 'pointer',
              '&:hover': {
                textDecoration: 'underline',
              },
            }}
            onClick={handleEdit}
          >
            {backendUrl || 'No backend configured'}
          </Typography>
          <IconButton size="small" onClick={handleEdit}>
            <EditIcon fontSize="small" />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
